import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import PillButton from '../components/PillButton';

function MongoDBPage() {
  const [queryResult, setQueryResult] = useState('');

  const showQueryResult = () => {
    setQueryResult(
      <div>
        <p>{`{ "name": "John Doe", "email": "john@example.com", "age": 30 }`}</p>
        <p>{`{ "name": "Jane Smith", "email": "jane@example.com", "age": 28 }`}</p>
      </div>
    );
  };

  return (
    <>
      {/* Hero Section */}
      <header className="hero-section text-center" role="banner">
        <div className="container">
          <h1>MongoDB Basics</h1>
          <p className="lead">Learn the fundamentals of MongoDB</p>
        </div>
      </header>

      {/* Main Content */}
      <main className="container py-5" role="main">
        <section id="mongodb-content" aria-labelledby="mongodb-heading">
          <h2 id="mongodb-heading">Introduction to MongoDB</h2>
          <p>
            MongoDB is a NoSQL database that stores data in JSON-like documents. It is designed for scalability and flexibility, making it ideal for modern web applications.
          </p>

          {/* Chunk 1: Basic MongoDB Command */}
          <div className="chunk">
            <h3>1. Basic MongoDB Command</h3>
            <p>Here’s an example of inserting a document into a MongoDB collection:</p>
            <div className="code-snippet">
              <pre>
                {`db.users.insertOne({
"name": "John Doe",
"email": "john@example.com",
"age": 30
})`}
</pre>

</div> <div className="tip"> <strong>Tip:</strong> Use <code>mongosh</code> to interact with MongoDB from the command line. </div> </div>
{/* Chunk 2: Querying Data */}

<div className="chunk"> <h3>2. Querying Data</h3> <p>Use the <code>find</code> method to query documents:</p> <div className="code-snippet"> <pre> {`db.users.find({ "age": { $gt: 25 } })`} </pre> </div> <p><strong>Try it:</strong> Click below to see a sample query result!</p> <PillButton onClick={showQueryResult}>Show Query Result</PillButton> <div id="query-demo">{queryResult}</div> <div className="tip"> <strong>Tip:</strong> Use <code>$gt</code> to find documents where a field is greater than a specified value. </div> </div>
</section> </main> </> ); }
export default MongoDBPage;